export const AWAITING_FEEDBACK = "Waiting for customer feedback";
export const COMPLEXITY = "Complexity";
export const FINISHING_DATE = "Estimated Finishing Date";
export const SOLUTION_TYPE = "Type of Solution";
export const TAPE_USED = "Tape in Use";
export const SUPPORT_TYPE = "Type of Support";
